/**
 * Logger Utility
 * 
 * 統一的日誌管理工具
 * 支援不同級別的日誌輸出，並可在生產環境中禁用
 */

const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4,
};

// 根據環境設置日誌級別
const getLogLevel = () => {
  if (process.env.NODE_ENV === 'production') {
    return LOG_LEVELS.ERROR; // 生產環境只記錄錯誤
  }
  return LOG_LEVELS.DEBUG; // 開發環境記錄所有日誌
};

const currentLogLevel = getLogLevel();

/**
 * 日誌工具類
 */
class Logger {
  constructor(prefix = '') {
    this.prefix = prefix;
  }

  /**
   * 格式化日誌消息
   */
  formatMessage(level, message, ...args) {
    const timestamp = new Date().toISOString();
    const prefix = this.prefix ? `[${this.prefix}]` : '';
    return [`[${timestamp}] ${prefix} [${level}]`, message, ...args];
  }

  /**
   * Debug 日誌
   */
  debug(message, ...args) {
    if (currentLogLevel <= LOG_LEVELS.DEBUG) {
      console.debug(...this.formatMessage('DEBUG', message, ...args));
    }
  }

  /**
   * Info 日誌
   */
  info(message, ...args) {
    if (currentLogLevel <= LOG_LEVELS.INFO) {
      console.info(...this.formatMessage('INFO', message, ...args));
    }
  }

  /**
   * Warning 日誌
   */
  warn(message, ...args) {
    if (currentLogLevel <= LOG_LEVELS.WARN) {
      console.warn(...this.formatMessage('WARN', message, ...args));
    }
  }

  /**
   * Error 日誌
   */
  error(message, ...args) {
    if (currentLogLevel <= LOG_LEVELS.ERROR) {
      console.error(...this.formatMessage('ERROR', message, ...args));
    }
  }
}

// 創建默認 logger
const defaultLogger = new Logger();

// 導出默認 logger 和 Logger 類
export default defaultLogger;
export { Logger, LOG_LEVELS };

/**
 * 創建帶前綴的 logger
 * @param {string} prefix - 日誌前綴
 * @returns {Logger} Logger 實例
 */
export const createLogger = (prefix) => {
  return new Logger(prefix);
};

